import { isUndefined } from 'lodash-es';
import { ORDERED_APP_ROUTE_LIST } from '../../config/app';
export const handleSkipCurrentPage = ({ fromPage, currentPage, navigate, nextPage, prevPage, }) => {
    // #NOTES
    // fromPage is undefined when the user directly accesses the current page
    // in this case, we redirect the user to the next page by default
    if (isUndefined(fromPage)) {
        if (nextPage) {
            navigate(nextPage);
        }
    }
    const fromPageIndex = ORDERED_APP_ROUTE_LIST.indexOf(fromPage);
    const currentPageIndex = ORDERED_APP_ROUTE_LIST.indexOf(currentPage);
    if (fromPageIndex < 0 || currentPageIndex < 0)
        return;
    if (fromPageIndex === currentPageIndex)
        return;
    if (fromPageIndex < currentPageIndex) {
        if (nextPage) {
            navigate(nextPage);
        }
        else {
            navigate(fromPage);
        }
        return;
    }
    if (fromPageIndex > currentPageIndex) {
        if (prevPage) {
            navigate(prevPage);
        }
        else {
            navigate(fromPage);
        }
    }
};
